import { setToken } from "@/api/services/http.service";

export default {
  SET_TOKEN(state, token) {
    setToken(token);
    state.token = token;

    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
    }
  },
};
